import { ReactNode, useEffect, useRef, useState } from "react";
import { Stack } from "@mui/material";

type Props = {
  header: (expanded: boolean) => ReactNode;
  children: ReactNode;
  initialExpanded?: boolean;
  onExpandedHandler?: () => void;
};

export const ReuseAccordion = ({
  header,
  children,
  initialExpanded = true,
  onExpandedHandler,
}: Props) => {
  const [expanded, setExpanded] = useState<boolean>(initialExpanded);
  const [maxHeight, setMaxHeight] = useState<number>(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setExpanded(initialExpanded);
  }, [initialExpanded]);

  useEffect(() => {
    if (contentRef.current) {
      setMaxHeight(expanded ? contentRef.current.scrollHeight : 0);
    }
    expanded && onExpandedHandler && onExpandedHandler();
  }, [expanded]);

  return (
    <Stack
      sx={{
        flexGrow: 1,
      }}
    >
      <Stack
        onClick={() => setExpanded(!expanded)}
        sx={{
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "nowrap",
          cursor: "pointer",
          gap: "4px",
        }}
      >
        {header(expanded)}
      </Stack>
      <Stack
        sx={{
          maxHeight,
          opacity: expanded ? 1 : 0,
          transition: "max-height 0.3s ease, opacity 0.3s ease",
          overflow: "hidden",
        }}
      >
        <div ref={contentRef}>{children}</div>
      </Stack>
    </Stack>
  );
};
